import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const s3UploadBaseQuery = fetchBaseQuery({
  baseUrl: ``, // Not needed because presigned URL is full
  prepareHeaders: (headers) => {
    headers.delete('authorization'); // force delete just in case
    return headers;
  },
});